<template>
  <div id="boxLogin" class="m-h1">
    <div
      class="is-justify-center is-align-center is-flex-medium is-flex-column boxFormSigUp"
    >
      <b-field
        :label="$t('resetPassword.labelPassword')"
        :type="$v.password.$error == true ? 'is-danger' : ''"
        :message="
          $v.password.$error == true ? $t('resetPassword.validatePassword') : ''
        "
        class="label-Left reveal"
      >
        <b-input
          :placeholder="$t('resetPassword.placeholderPassword')"
          @input="$v.password.$touch()"
          type="password"
          password-reveal
          icon-pack="mdi"
          icon="lock"
          v-model="password"
        >
        </b-input>
      </b-field>
      <b-field
        :label="$t('resetPassword.labelConfirmPassword')"
        class="label-Left is-padding-top-m reveal"
        :type="$v.repassword.$error == true ? 'is-danger' : ''"
        :message="
          $v.repassword.$error == true
            ? $t('resetPassword.validateConfirmPassword')
            : ''
        "
      >
        <b-input
          :placeholder="$t('resetPassword.placeholderConfirmPassword')"
          type="password"
          password-reveal
          icon-pack="mdi"
          icon="lock"
          v-model="repassword"
          @input="$v.repassword.$touch()"
        >
        </b-input>
      </b-field>
    </div>
    <div class="boxBtnSignIn">
      <button class="button is-btn-link is-size-6" @click="sentForgotToEmail">
        {{ $t("message.btnSend") }}
      </button>
    </div>
  </div>
</template>
<script>
import { HTTP } from "@/axios.js";
import {
  required,
  minLength,
  sameAs,
  between,
  numeric,
  email,
  helpers,
} from "vuelidate/lib/validators";

export default {
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    repassword: {
      sameAsPassword: sameAs("password"),
    },
  },
  data() {
    return {
      password: "",
      repassword: "",
    };
  },
  methods: {
    sentForgotToEmail() {
      this.$v.$touch();

      if (this.$v.$invalid) {
      } else {
        const data = {
          token: this.$route.params.token,
          password: this.password,
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${data.token}`;
        HTTP.post("/api/user/update/password", data)
          .then((res) => {
            // console.log('/api/user/update/password', res);
            if (res.data.success) {
              this.$buefy.dialog.alert({
                message:
                  '<p class="has-text-centered is-size-5">แก้ไขรหัสผ่านเรียบร้อยแล้ว</p>',
                confirmText: "ตกลง",
                onConfirm: () => this.$router.push("/signin"),
              });
            } else {
              this.$buefy.dialog.alert({
                message:
                  '<p class="has-text-centered is-size-5">ยืนยันตัวตนการแก้ไขรหัสผ่านล้มเหลว กรุณากดแก้ไขรหัสผ่านใหม่อีกครั้ง</p>',
                confirmText: "ตกลง",
                onConfirm: () => this.$router.push("/signin"),
              });
            }
          })
          .catch((e) => {
            console.log("/api/user/update/password/error", e);
          });
      }
    },
  },
};
</script>
<style>
.boxError {
  border: 1px solid red;
  color: red;
  padding: 20px;
  text-align: center;
  background: #f7d0d0;
}
.forgotText {
  text-align: right;
  font-size: 1rem !important;
  color: #6d8df3;
  margin-top: 0.5rem;
}

#boxPassWord {
  margin-top: 1.5rem;
}
.boxBtnSignIn {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
#boxSignUp {
  margin-bottom: 2rem;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
</style>
